// import React from "react";
// import TopCategoriesTabs from "../components/HomeComponents/TopCategoriesTabs";
// import Banner from "../components/HomeComponents/Banner";
// import SubCategoriesList from "../components/HomeComponents/SubCategoriesList";
// import SubCategoriesCards from "../components/HomeComponents/SubCategoriesCards";

// function Home() {
//   return (
//     <div>
//       <TopCategoriesTabs />
//       <Banner />
//       <SubCategoriesList />
//       <SubCategoriesCards />
//     </div>
//   );
// }

// export default Home;


// import React, { useState } from "react";
// import TopCategoriesTabs from "../components/HomeComponents/TopCategoriesTabs";
// import Banner from "../components/HomeComponents/Banner";
// import SubCategoriesList from "../components/HomeComponents/SubCategoriesList";
// import SubCategoriesCards from "../components/HomeComponents/SubCategoriesCards";
// import BestsellerSection from "../components/productComponents/BestsellerSection";
// import products from "../data/products";

// import NewArrivals from "../components/productComponents/NewArrivals";

// function Home() {
//   // Client requirement → default WOMEN
//   const [activeCategory, setActiveCategory] = useState("women");

//   return (
//     <div>
//       <TopCategoriesTabs
//         activeCategory={activeCategory}
//         onCategoryChange={setActiveCategory}
//       />

//       <Banner category={activeCategory} />

//       <SubCategoriesList category={activeCategory} />

//       <SubCategoriesCards category={activeCategory} />
//         {/* CATEGORY-WISE BESTSELLER */}
//   <BestsellerSection
//     title={` Bestsellers`}
//     category={activeCategory}
//     products={products}
//   />

//   {/* NEW ARRIVALS */}
//   <NewArrivals category={activeCategory} products={products} limit={8} />
//     </div>
//   );
// }

// export default Home;

import React, { useState, useEffect } from "react";
import TopCategoriesTabs from "../components/HomeComponents/TopCategoriesTabs";
import Banner from "../components/HomeComponents/Banner";
import SubCategoriesList from "../components/HomeComponents/SubCategoriesList";
import SubCategoriesCards from "../components/HomeComponents/SubCategoriesCards";
import BestsellerSection from "../components/productComponents/BestsellerSection";
import NewArrivals from "../components/HomeComponents/NewArrivals";
import products from "../data/products";
import SummaryApi from "../common/SummaryApi";
import KidsAgeGroups from "../components/productComponents/KidsAgeGroups";
// import EmailSubscription from "./EmailSubscription";
import OfferPage from "../components/HomeComponents/OfferPage";
import SubCategoryRowSection from "../components/HomeComponents/SubCategoryRowSection";

function Home() {
  const [activeCategory, setActiveCategory] = useState("women");

  const normalizedActive = (activeCategory || "").toLowerCase();

  const [bestSellers, setBestSellers] = useState([]);

const fetchBestSellers = async (categorySlug) => {
  try {
    const response = await fetch(
      SummaryApi.fetchTopSelling.url(categorySlug),
      {
        method: SummaryApi.fetchTopSelling.method
      }
    );

    const data = await response.json();

    if (data.success) {
      setBestSellers(data.data);
    }
  } catch (error) {
    console.error("Fetch bestseller error", error);
  }
};
useEffect(() => {
  if (activeCategory) {
    fetchBestSellers(activeCategory.toLowerCase());
  }
}, [activeCategory]);

  const categoryProducts = products.filter((p) => {
    const slug = (p.categorySlug || p.category || "").toString().toLowerCase();
    return slug === normalizedActive;
  });

  const displayName =
    categoryProducts[0]?.category ||
    (activeCategory ? activeCategory.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "");
  // Client requirement → default WOMEN

  return (
    <div>
      <TopCategoriesTabs
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
      />

      <Banner category={activeCategory} />

      <SubCategoriesList category={activeCategory} />
        <SubCategoriesCards category={activeCategory} />

      {normalizedActive === "kids" && <KidsAgeGroups />}

      <div className="">

     <SubCategoryRowSection category={activeCategory} />
      </div>

    <BestsellerSection
  title={`${displayName} Bestsellers`}
  products={bestSellers}
/>


      {/* NEW ARRIVALS */}
      <NewArrivals category={activeCategory} limit={8} />
      {/* <SubCategoriesCards category={activeCategory} /> */}
      <Banner category={activeCategory} rounded />    
      <OfferPage category={activeCategory} />
      {/* <EmailSubscription/> */}
    </div>
  );
}

export default Home;